module.exports = __webpack_public_path__ + "static/img/drive-icon.87782c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/tools/drive-icon.png
// module id = z+aF
// module chunks = 0